export default "__VITE_ASSET__BSXKS3TZ__"